export default __webpack_public_path__ + "static/media/aibv.4ee18591.svg";